import PurchasePreview from "./PurchasePreview";

export default PurchasePreview;
